/**
 * @generated SignedSource<<a643fbd3923a094e0b498e1615e92000>>
 * @relayHash 3ba2473df321be430db6c856602e1cfc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 276d3b41fdfa3d291bf08ded53ed193db1a7ba6d83bd886ac6ec292d3dabf482

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceRequestAccessApprovalDecision = "APPROVE" | "DENY" | "%future added value";
export type ResourceAccessType = "EDIT" | "VIEW" | "%future added value";
export type ConfluenceUpdateContentAccessRequestInput = {
  accessRequestedAccountId: string;
  accessType: ResourceAccessType;
  approvalDecision: ConfluenceRequestAccessApprovalDecision;
  contentId: string;
  requestId: string;
};
export type useRealtimeAccessRequestsFlagsMutation$variables = {
  cloudId: string;
  updateContentAccessRequestInput: ConfluenceUpdateContentAccessRequestInput;
};
export type useRealtimeAccessRequestsFlagsMutation$data = {
  readonly confluence_updateContentAccessRequest: {
    readonly errors: ReadonlyArray<{
      readonly message: string | null | undefined;
    }>;
    readonly success: boolean;
  } | null | undefined;
};
export type useRealtimeAccessRequestsFlagsMutation = {
  response: useRealtimeAccessRequestsFlagsMutation$data;
  variables: useRealtimeAccessRequestsFlagsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "updateContentAccessRequestInput"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "updateContentAccessRequestInput",
        "variableName": "updateContentAccessRequestInput"
      }
    ],
    "concreteType": "ConfluenceUpdateContentAccessRequestPayload",
    "kind": "LinkedField",
    "name": "confluence_updateContentAccessRequest",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useRealtimeAccessRequestsFlagsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useRealtimeAccessRequestsFlagsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3ba2473df321be430db6c856602e1cfc",
    "id": "276d3b41fdfa3d291bf08ded53ed193db1a7ba6d83bd886ac6ec292d3dabf482",
    "metadata": {},
    "name": "useRealtimeAccessRequestsFlagsMutation",
    "operationKind": "mutation",
    "text": "mutation useRealtimeAccessRequestsFlagsMutation($cloudId:ID!,$updateContentAccessRequestInput:ConfluenceUpdateContentAccessRequestInput!){confluence_updateContentAccessRequest(cloudId:$cloudId,updateContentAccessRequestInput:$updateContentAccessRequestInput){success,errors{message}}}"
  }
};
})();

(node as any).hash = "42de35f8c9cecb62158728d903eff6a2";

export default node;
